import { indexZones } from "@/mocks/homeData";

export default function IndexZones() {
  return (
    <section id="zones" className="w-full border-b border-background-200/70 bg-background-50 px-4 py-14 md:px-6 md:py-20">
      <div className="mx-auto max-w-6xl">
        <div className="mb-8 flex flex-col gap-3 md:mb-10 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="mb-2 flex items-center gap-2 text-xs font-medium text-primary-600 md:text-sm">
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-layout-grid-line text-base" aria-hidden="true"></i>
              </span>
              模块 05 · 黑料索引分区
            </p>
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
              按领域划分的索引分区
            </h2>
            <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
              索引按领域分区存放，你可以先选领域，再用关键词在分区内二次定位，减少无关条目干扰。
            </p>
          </div>
          <p className="w-fit rounded-full bg-primary-100 px-3.5 py-1.5 text-xs font-medium text-primary-700 md:text-sm">
            共 8 个分区 · 每日更新
          </p>
        </div>

        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
          {indexZones.map((zone, index) => (
            <a
              key={zone.name}
              href="#latest"
              style={{ animationDelay: `${index * 45}ms` }}
              className="animate-fade-up group flex flex-col rounded-lg border border-background-200/80 bg-background-100/60 p-4 transition-colors hover:border-primary-300 hover:bg-background-100 md:p-5"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-background-50 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={`${zone.icon} text-xl`} aria-hidden="true"></i>
                </span>
                <span className="font-heading text-lg font-bold text-foreground-950">{zone.count}</span>
              </div>
              <h3 className="mt-3.5 font-heading text-base font-bold text-foreground-950 md:text-lg">
                {zone.name}
              </h3>
              <p className="mt-1.5 flex-1 text-sm leading-relaxed text-foreground-600">{zone.desc}</p>
              <span className="mt-3 flex items-center gap-1 text-xs font-medium text-primary-600">
                进入分区
                <span className="flex h-3.5 w-3.5 items-center justify-center transition-transform group-hover:translate-x-0.5">
                  <i className="ri-arrow-right-line text-sm" aria-hidden="true"></i>
                </span>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}